import React from "react";
import {
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  paper: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  colorSwatch: {
    width: 60,
    height: 20,
    borderRadius: 4,
    margin: "0 auto",
  },
}));

const IntegrationQueueTable = ({
  queues = [],
  enabledQueueIds = [],
  onToggle,
  title,
  description,
}) => {
  const classes = useStyles();

  const isEnabled = queueId => enabledQueueIds.includes(Number(queueId));

  return (
    <Paper variant="outlined" className={classes.paper}>
      <Typography variant="subtitle1" sx={{ p: 2, pb: 0, fontWeight: 600 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="textSecondary" sx={{ px: 2, pb: 1 }}>
          {description}
        </Typography>
      )}
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Fila</TableCell>
            <TableCell align="center">Cor</TableCell>
            <TableCell align="center">Integração ativa</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {queues.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                Nenhuma fila cadastrada.
              </TableCell>
            </TableRow>
          ) : (
            queues.map(queue => (
              <TableRow key={queue.id}>
                <TableCell align="center">{queue.name}</TableCell>
                <TableCell align="center">
                  <div
                    className={classes.colorSwatch}
                    style={{ backgroundColor: queue.color }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Switch
                    color="primary"
                    checked={isEnabled(queue.id)}
                    onChange={e => onToggle(queue.id, e.target.checked)}
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default IntegrationQueueTable;
